
export class LOVNotQualifyReasonExtension {
}
